import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { usePermission } from "../../../context/PermissionContext";
import { useNetwork } from "../../../context/NetworkContext";
import { useAuth } from "../../../context/AuthProvider";
import { useShowAlert } from "../../../context/AlertContext";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import priceCalculator from "@heartinz/gst_india_product_price_calculator";
import {
  getPurchaseAmount,
  toPrimaryQuantity,
  toSecondaryQuantity,
} from "@heartinz/finance";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import { CircularProgress } from "@mui/material";
import uRLs from "../../../utils/baseUtils";
import { CheckIcon, XIcon } from "../../../constants/Icons";

const EditStockModel = ({ onclose, onStockUpdate, stockItem, finalLand }) => {
  // console.log(stockItem);
  const location = useLocation();
  const [error, setErrors] = useState("");
  const [isBtnLoading, setBtnLoading] = useState(false);
  const { checkNetwork } = useNetwork();
  const { isUser } = useAuth();
  const serverTime = GetServerLiveTime();
  const showAlert = useShowAlert();
  const { permission } = usePermission();
  const iso = serverTime.toISOString();
  const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
  const quantityRef = useRef(null);
  const productMrpRef = useRef(null);
  const productsalepriceRef = useRef(null);
  const producttaxpercentageRef = useRef(null);
  const productbasepriceRef = useRef(null);
  const popupMrpInputRef = useRef(null);
  const purchaseAmountRef = useRef(null);
  const updateBtnRef = useRef(null);
  const purchasewithtaxref = useRef(null);
  const purchasewithouttaxRef = useRef(null);
  const [showMrpPopup, setShowMrpPopup] = useState(false);
  const [popupMrpValue, setPopupMrpValue] = useState("");
  const [popupMrpStyle, setPopupMrpStyle] = useState({});
  const modalBodyRef = useRef(null);

  const [manufacturedate, setMDate] = useState("");
  const [expiredate, setEDate] = useState("");
  const [expireMinDate, setExpireMinDate] = useState(iso);
  const [openPicker, setOpenPicker] = useState(null);
  const [selectedProduct, setselectedProduct] = useState(null);
  const [addToStock, setAddToStock] = useState(true);

  const [openMfgDate, setOpenMfgDate] = useState(false);
  const [openExpDate, setOpenExpDate] = useState(false);

  const [isProductData, setProductData] = useState({
    mrp: 0,
    saleprice: 0,
    taxpercentage: 0,
    discount: 0,
    baseprice: 0,
    taxamount: 0,
    quantity: 0,
    purchaseWithTax: 0,
    purchaseWithoutTax: 0,
    isLock: "SALEPRICE",
    totalPurchaseAmountLock: "WITHTAX",
    ratePerUnit: 0,
    isSecondaryUnit: false,
  });
  const { viewOption } = usePermission();
  const unitConfig = isProductData?.unitConfig || {};
  const { primaryUnitCode, secondaryUnitCode } = unitConfig;
  const [selectedUnit, setSelectedUnit] = useState(primaryUnitCode || "");
  // console.log(isProductData);
  const handleMDateChange = (selectedDate) => {
    if (!selectedDate) return;

    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
    setProductData((prev) => ({
      ...prev,
      manufacturedate: indiaTime,
    }));

    setMDate(indiaTime);
    setExpireMinDate(indiaTime);
  };

  const handleEDateChange = (selectedDate) => {
    if (!selectedDate) return;

    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
    setProductData((prev) => ({
      ...prev,
      expiredate: indiaTime,
    }));
    setEDate(indiaTime);
  };

  useEffect(() => {
    if (stockItem) {
      const lockType =
        stockItem.totalPurchaseAmountLock ||
        stockItem.lineTotalPurchaseAmountLock ||
        "WITHTAX";

      setProductData({
        ...stockItem,
        mrp: CurrencyConverter.toCurrency(stockItem.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(stockItem.saleprice, "INR"),
        taxpercentage: stockItem.taxpercentage,
        discount: CurrencyConverter.toCurrency(
          stockItem.purchaseDiscount,
          "INR",
        ),
        baseprice: CurrencyConverter.toCurrency(
          stockItem.saleAmountList.basePrice,
          "INR",
        ),
        taxamount: CurrencyConverter.toCurrency(
          stockItem.purchaseTaxAmount,
          "INR",
        ),
        quantity: stockItem.isSecondaryUnit
          ? toSecondaryQuantity(
              stockItem.purchaseQuantity || 0,
              stockItem.unitConfig || {},
            )?.secondaryQty || 0
          : stockItem.purchaseQuantity || 0,

        isSecondaryUnit: stockItem.isSecondaryUnit,
        unitConfig: stockItem.unitConfig || {},
        purchaseWithTax: CurrencyConverter.toCurrency(
          stockItem.lineTotalPurchasePriceWithTax,
          "INR",
        ),
        purchaseWithoutTax: CurrencyConverter.toCurrency(
          stockItem.lineTotalPurchasePriceWithoutTax,
          "INR",
        ),

        manufacturedate: stockItem.manufactureDate || null,
        expiredate: stockItem.expireDate || null,

        // ✅ IMPORTANT
        totalPurchaseAmountLock: lockType,

        hsnsac: stockItem.hsnsac,
        ratePerUnit: CurrencyConverter.toCurrency(
          stockItem.purchasePriceWithTax,
          "INR",
        ),
      });

      setAddToStock(
        stockItem.addToStock !== undefined ? stockItem.addToStock : true,
      );
      setselectedProduct({
        title: stockItem.title,
        hsnsac: stockItem.hsnsac,
        code: stockItem.code,
        brandId: stockItem.brandId,
        totalStockLeft: stockItem.totalStockLeft,
        note: stockItem.note,
      });
      setSelectedUnit(
        stockItem.isSecondaryUnit
          ? stockItem?.unitConfig?.secondaryUnitCode
          : stockItem?.unitConfig?.primaryUnitCode,
      );
      productMrpRef.current?.focus();
      // Optional
      if (stockItem.manufactureDate) {
        setMDate(stockItem.manufactureDate);

        setExpireMinDate(stockItem.manufactureDate); // 🔥 critical
      }

      if (stockItem.expireDate) {
        setEDate(stockItem.expireDate);
      }
    }
  }, [stockItem]);

  // const handleCalculate = (updatedData) => {
  //   let { mrp, saleprice, baseprice, taxpercentage } = updatedData;
  //   let numericMrp = CurrencyConverter.toSubunit(mrp || 0, "INR");
  //   let numericSaleprice = CurrencyConverter.toSubunit(saleprice || 0, "INR");
  //   let numericBaseprice = CurrencyConverter.toSubunit(baseprice || 0, "INR");
  //   let numericTaxpercentage = parseInt(taxpercentage);

  //   try {
  //     const calc = priceCalculator.getAllPriceList(
  //       numericMrp,
  //       numericSaleprice,
  //       numericBaseprice,
  //       numericTaxpercentage,
  //       1,
  //       updatedData.isLock,
  //     );

  //     setProductData((prev) => ({
  //       ...prev,
  //       baseprice: CurrencyConverter.toCurrency(calc.basePrice, "INR"),
  //       saleprice: CurrencyConverter.toCurrency(calc.salePrice, "INR"),
  //       mrp: CurrencyConverter.toCurrency(calc.mrp, "INR"),
  //       discount: CurrencyConverter.toCurrency(calc.discount, "INR"),
  //       taxamount: CurrencyConverter.toCurrency(calc.gstAmount, "INR"),
  //     }));
  //   } catch (e) {
  //     showAlert("warning", e.message);
  //   }
  // };

  const handleCalculate = (data) => {
    try {
      // ✅ 1. Helpers (convert once)
      const toSub = (val) =>
        Number(CurrencyConverter.toSubunit(val || 0, "INR")) || 0;

      const toCur = (val) => CurrencyConverter.toCurrency(val || 0, "INR");

      // ✅ 2. Normalize all inputs
      const numeric = {
        mrp: toSub(data.mrp),
        saleprice: toSub(data.saleprice),
        baseprice: toSub(data.baseprice),
        purchaseWithTax: toSub(data.purchaseWithTax),
        purchaseWithoutTax: toSub(data.purchaseWithoutTax),
        quantity: Number(
          data?.isSecondaryUnit
            ? toPrimaryQuantity(
                parseFloat(data.quantity) || 0,
                data?.unitConfig || {},
              )?.primaryQty
            : parseFloat(data.quantity) || 0,
        ),
        tax: parseInt(data.taxpercentage) || 0,
      };

      // console.log("Numeric Inputs for Calculation:", numeric);

      // ✅ 3. Safety rule
      if (numeric.saleprice > numeric.mrp) {
        numeric.mrp = numeric.saleprice;
      }

      const lock = data.isLock;
      const purchaseLockType = data.totalPurchaseAmountLock;

      // ✅ 4. Single calculation (🔥 CORE)
      const result = getPurchaseAmount(
        numeric.mrp,
        numeric.saleprice,
        numeric.baseprice,
        lock,
        numeric.tax,
        numeric.quantity,
        numeric.purchaseWithTax,
        numeric.purchaseWithoutTax,
        purchaseLockType,
        data?.unitConfig && Object.keys(data.unitConfig || {}).length > 0
          ? data.unitConfig
          : undefined,
      );

      // console.log("Calculation Result:", result);

      const { saleAmountList, purchaseAmountList } = result;

      // ✅ 5. Update state (respect locks)
      setProductData((prev) => ({
        ...prev,

        // ===== SALE =====
        mrp: toCur(saleAmountList.mrp),

        saleprice:
          lock === "SALEPRICE"
            ? prev.saleprice
            : toCur(saleAmountList.salePrice),

        baseprice:
          lock === "BASEPRICE"
            ? prev.baseprice
            : toCur(saleAmountList.basePrice),

        discount: toCur(saleAmountList.discount),
        taxamount: toCur(saleAmountList.taxAmount),

        // ===== PURCHASE =====
        ratePerUnit: toCur(purchaseAmountList.purchasePriceWithTax),
        purchaseWithTax:
          purchaseLockType === "WITHTAX"
            ? prev.purchaseWithTax
            : toCur(purchaseAmountList.lineTotalPurchasePriceWithTax),

        purchaseWithoutTax:
          purchaseLockType === "WITHOUTTAX"
            ? prev.purchaseWithoutTax
            : toCur(purchaseAmountList.lineTotalPurchasePriceWithoutTax),

        // optional raw numeric (if needed)
        purchaseamount:
          purchaseLockType === "WITHTAX"
            ? purchaseAmountList.lineTotalPurchasePriceWithTax
            : purchaseAmountList.lineTotalPurchasePriceWithoutTax,
      }));
    } catch (error) {
      console.error("CALC ERROR:", error);
      showAlert("warning", error.message || Messages.ERROR.INVALID_INPUT);
    }
  };

  // const handleChange = (e) => {
  //   setErrors("");
  //   const { name, value } = e.target;
  //   let inputValue = value;
  //   if (name === "saleprice" || name === "baseprice" || name === "mrp") {
  //     const regex = /^$|^\d*\.?\d{0,2}$/;
  //     if (!regex.test(value)) {
  //       return;
  //     }
  //     inputValue = value;
  //   }
  //   if (name === "taxpercentage") {
  //     const allowedValues = [0, 5, 12, 18, 24];
  //     if (!allowedValues.includes(Number(value))) inputValue = 0;
  //   }

  //   if (["quantity"].includes(name) && !/^[0-9]*$/.test(value)) {
  //     inputValue = "";
  //   }

  //   if (name === "purchaseamount") {
  //     const regex = /^$|^\d*\.?\d{0,2}$/;
  //     if (!regex.test(value)) return;

  //     let purchaseValue = Number(value);
  //     let taxPercent = Number(isProductData.taxpercentage || 0);

  //     let basePurchase = purchaseValue;
  //     let taxAmount = 0;

  //     if (purchaseLock === "WITH_TAX") {
  //       // Extract base price from tax-inclusive value
  //       basePurchase = purchaseValue / (1 + taxPercent / 100);
  //       taxAmount = purchaseValue - basePurchase;
  //     } else {
  //       // Add tax on top
  //       taxAmount = (purchaseValue * taxPercent) / 100;
  //     }
  //     const updatedData = {
  //       ...isProductData,
  //       purchaseamount: value,
  //       purchaseBase: basePurchase,
  //       purchaseTax: taxAmount,
  //     };

  //     setProductData(updatedData);
  //     return;
  //   }
  //   const updatedData = {
  //     ...isProductData,
  //     [name]: inputValue,
  //   };
  //   setProductData(updatedData);
  //   handleCalculate(updatedData);
  // };

  const handleChange = (e) => {
    setErrors("");

    const { name, value } = e.target;

    // ✅ Validators
    const isDecimal = /^$|^\d*\.?\d{0,2}$/;
    const isInteger = /^[0-9]*$/;

    let inputValue = value;

    // ✅ 1. Validation
    if (
      [
        "mrp",
        "saleprice",
        "baseprice",
        "purchaseWithTax",
        "purchaseWithoutTax",
      ].includes(name)
    ) {
      if (!isDecimal.test(value)) return;
    }

    if (name === "quantity") {
      if (uRLs.UNIT === "true" && isProductData?.unitConfig) {
        const isSecondary =
          selectedUnit === isProductData?.unitConfig?.secondaryUnitCode;

        if (isSecondary) {
          // secondary unit -> allow 1 decimal
          if (!/^\d*\.?\d{0,1}$/.test(value)) {
            return;
          }
        } else {
          // primary unit -> allow 3 decimals
          if (!/^\d*\.?\d{0,3}$/.test(value)) {
            return;
          }
        }
      } else {
        // no unit config -> integer only
        if (!/^\d*$/.test(value)) {
          return;
        }
      }
    }

    if (name === "taxpercentage") {
      const allowed = [0, 5, 12, 18, 24];
      inputValue = allowed.includes(Number(value)) ? value : 0;
    }

    // ✅ 2. Build updated state
    let updatedData = {
      ...isProductData,
      [name]: inputValue,
    };

    // ✅ 3. Auto SALE lock
    if (name === "saleprice" || name === "baseprice") {
      updatedData.isLock = name === "saleprice" ? "SALEPRICE" : "BASEPRICE";
    }

    // ✅ 4. Purchase lock handling (🔥 IMPORTANT)
    if (name === "purchaseWithTax" || name === "purchaseWithoutTax") {
      const lockType = name === "purchaseWithTax" ? "WITHTAX" : "WITHOUTTAX";

      updatedData.totalPurchaseAmountLock = lockType; // sync radio
    }

    // ✅ 5. Update state first
    setProductData(updatedData);

    // ✅ 6. Prevent useless calculations
    if (inputValue !== "" && inputValue !== ".") {
      handleCalculate(updatedData);
    }
  };

  // const handleRadioChange = (type) => {
  //   setProductData((prev) => ({ ...prev, isLock: type }));
  // };

  const validateForm = () => {
    const errors = {};

    if (!isProductData.saleprice) errors.saleprice = "Sale price required";

    if (!isProductData.baseprice) errors.baseprice = "Base price required";

    if (
      isProductData.quantity === undefined ||
      isProductData.quantity === null ||
      isProductData.quantity === "" ||
      parseFloat(isProductData.quantity || 0) <= 0
    ) {
      errors.quantity = "Quantity required";
    } else {
      const isSecondary =
        selectedUnit === isProductData?.unitConfig?.secondaryUnitCode;

      const isValidQty =
        uRLs.UNIT === "true" && isProductData?.unitConfig
          ? isSecondary
            ? /^\d*\.?\d{0,1}$/.test(isProductData.quantity)
            : /^\d*\.?\d{0,3}$/.test(isProductData.quantity)
          : /^\d+$/.test(isProductData.quantity);

      if (!isValidQty) {
        errors.quantity = "Invalid quantity";
      }
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const primaryQty = isProductData?.isSecondaryUnit
    ? toPrimaryQuantity(
        Number(isProductData.quantity) || 0,
        isProductData?.unitConfig || {},
      )?.primaryQty
    : Number(isProductData.quantity) || 0;

  const handleUpdate = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const updatedData = {
      ...isProductData,
      quantity: Number(primaryQty), // ✅ FIX
      // purchaseamount: Number(isProductData.purchaseamount), // ✅ FIX
      // purchaseBase: Number(isProductData.purchaseBase || 0), // ✅ FIX
      addToStock: addToStock,
    };
    onStockUpdate(updatedData);
    onclose();
  };

  const handleFieldFocus = (e) => {
    e.target.select?.();
    // setOpenPicker(null);
  };

  const handleClose = async () => {
    resetForm();
    onclose();
  };

  const resetForm = () => {
    setProductData({
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
      quantity: 0,
      purchaseWithTax: 0,
      purchaseWithoutTax: 0,
      isLock: "SALEPRICE",
      totalPurchaseAmountLock: "WITHTAX",
    });
    setErrors("");
    setselectedProduct(null);
    // setSelectedRadio("SALEPRICE");
    setEDate(null);
    setMDate(null);
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onclose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onclose]);

  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const trimmedData = String(isProductData[fieldName] || "").trim();
      // const requiredFields = ["saleprice", "taxpercentage"];

      // if (requiredFields.includes(fieldName) && !trimmedData) {
      //   setErrors((prev) => ({
      //     ...prev,
      //     [fieldName]:
      //       Messages.ERROR[`${fieldName.toUpperCase()}_EMPTY`] || "Required",
      //   }));
      //   return;
      // }

      if (isLast) {
        handleUpdate(e);
      } else {
        const nextInput =
          nextRef?.current?.input ||
          nextRef?.current?.flatpickr?.input ||
          nextRef?.current?.querySelector?.("input") ||
          nextRef?.current;

        if (nextInput && typeof nextInput.focus === "function") {
          nextInput.focus();
        } else {
          console.warn("Cannot focus nextRef:", nextRef);
        }
      }
    }
  };

  const hasUnit =
    uRLs.UNIT === "true" && unitConfig && unitConfig.primaryUnitCode;

  return (
    <>
      <div className="modal-backdrop show"></div>
      <div className="modal show" style={{ display: "block" }}>
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Edit Stock</h6>
              <button className="btn-close" onClick={onclose}></button>
            </div>

            <div className="modal-body bg-light">
              <div className="row g-3">
                <div className="col-lg-6">
                  <div className="card h-100">
                    <div className="card-body">
                      <div className="col-lg-12 ">
                        <div className="card shadow-none border-blue mb-0">
                          <div className="card-header bg-light-blue p-2 d-flex justify-content-between align-items-center">
                            <div className="mb-0">Product info</div>
                            {selectedProduct?.title && (
                              <div>
                                {/* <button
                                  type="button"
                                  className="bg-light-blue rounded  shadow-none border-0"
                                  onClick={() => openEditModal(selectedProduct)}
                                >
                                  <i className="ng ng-ng-edit-icon"></i>
                                </button> */}
                              </div>
                            )}
                          </div>
                          <div className="card-body p-2">
                            {selectedProduct?.title ? (
                              <div>
                                {/* <p className="mb-1">
                                               Title :{" "}
                                               <span className="fw-600">
                                                 {selectedProduct?.title}
                                               </span>
                                             </p>
                                             <p className="mb-1">
                                               HSN :{" "}
                                               {selectedProduct?.hsnsac ? (
                                                 <span className="fw-600">
                                                   {selectedProduct?.hsnsac}
                                                 </span>
                                               ) : (
                                                 <>-</>
                                               )}
                                             </p> */}
                                {/* <p className="mb-1">
                                               SalePrice :{" "}
                                               <span className="fw-600">
                                                 ₹
                                                 {CurrencyConverter.toCurrency(
                                                   selectedProduct?.saleprice || 0,
                                                   "INR"
                                                 )}{" "}
                                               </span>
                                             </p> */}
                                <div className="d-flex ">
                                  <div
                                    className="mb-1 d-flex  gap-2"
                                    style={{ flexBasis: "100%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Title:
                                    </span>
                                    {selectedProduct?.title ? (
                                      <span className="fw-600">
                                        {selectedProduct?.title}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex ">
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      SKU Code:
                                    </span>
                                    {selectedProduct?.code ? (
                                      <span className="badge rounded-pill bg-label-navy">
                                        {selectedProduct?.code}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      HSN:
                                    </span>
                                    {selectedProduct?.hsnsac ? (
                                      <span className="badge rounded-pill bg-label-retro">
                                        {selectedProduct.hsnsac}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex ">
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Brand:
                                    </span>
                                    {selectedProduct?.brandId ? (
                                      <span className="badge bg-label-kids">
                                        {selectedProduct?.brandId}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Total Stock Left:
                                    </span>
                                    {selectedProduct?.totalStockLeft ? (
                                      <span className="badge bg-label-space">
                                        {selectedProduct.totalStockLeft}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex ">
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Note:
                                    </span>
                                    {selectedProduct?.note ? (
                                      <span className="badge bg-label-sun">
                                        {selectedProduct?.note}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                  {/* {uRLs.UNIT === "true" && (
                                    <div
                                      className="mb-2 d-flex align-items-center gap-2"
                                      style={{ flexBasis: "50%" }}
                                    >
                                      <span className="fw-semibold text-muted">
                                        Unit:
                                      </span>
                                      {defaultConversion?.unitName ? (
                                        <span className="badge rounded-pill btn-unit">
                                          {defaultConversion?.unitName} (
                                          {defaultConversion.unitCode})
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </div>
                                  )} */}
                                </div>
                              </div>
                            ) : (
                              <p className="mb-0 text-muted">
                                No products has been selected
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 border-top ">
                        <div className="fw-600 mt-2">
                          Amount{" "}
                          {selectedUnit ? (
                            <span className="">(Per {primaryUnitCode})</span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="row g-2 mt-1">
                        <div className="col-lg-4">
                          <label htmlFor="mrp" className="form-label">
                            {" "}
                            MRP{" "}
                          </label>
                          {!showMrpPopup && (
                            <input
                              type="text"
                              className="form-control"
                              name="mrp"
                              autoComplete="off"
                              autoFocus
                              ref={productMrpRef}
                              value={isProductData.mrp}
                              onFocus={handleFieldFocus}
                              onChange={handleChange}
                              onKeyDown={(e) =>
                                handleEnterKey(e, "mrp", productsalepriceRef)
                              }
                              onClick={() => {
                                const rect =
                                  productMrpRef.current.getBoundingClientRect();
                                setPopupMrpStyle({
                                  position: "absolute",
                                  top: `${rect.top + window.scrollY}px`,
                                  left: `${rect.left + window.scrollX}px`,
                                  width: `${rect.width}px`,
                                  zIndex: 10000,
                                });
                                setPopupMrpValue(isProductData.mrp);
                                setShowMrpPopup(true);
                              }}
                            />
                          )}
                          {showMrpPopup && (
                            <input
                              type="text"
                              ref={popupMrpInputRef}
                              value={popupMrpValue}
                              onChange={(e) => {
                                const val = e.target.value;
                                setPopupMrpValue(val);
                                setProductData((prev) => ({
                                  ...prev,
                                  mrp: val,
                                }));
                                handleCalculate({ ...isProductData, mrp: val });
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  setShowMrpPopup(false);
                                  setTimeout(() => {
                                    productsalepriceRef?.current?.focus();
                                  }, 0);
                                }
                              }}
                              onBlur={() => setShowMrpPopup(false)}
                              onFocus={handleFieldFocus}
                              // style={popupMrpStyle}
                              className="form-control"
                            />
                          )}
                          {error.mrp && (
                            <div className="invalid-feedback">{error.mrp}</div>
                          )}
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="saleprice" className="form-label">
                            Sale Price <span className="text-danger">*</span>
                          </label>

                          <div className="input-container position-relative">
                            <input
                              type="text"
                              name="saleprice"
                              autoComplete="off"
                              ref={productsalepriceRef}
                              value={isProductData.saleprice}
                              className="form-control"
                              onFocus={handleFieldFocus}
                              onClick={() => {
                                setProductData((prev) => ({
                                  ...prev,
                                  isLock: "SALEPRICE",
                                }));
                              }}
                              style={{ paddingLeft: "30px" }}
                              onChange={handleChange}
                              onKeyDown={(e) =>
                                handleEnterKey(
                                  e,
                                  "saleprice",
                                  producttaxpercentageRef,
                                )
                              }
                            />
                            <input
                              type="radio"
                              name="selectInput"
                              checked={isProductData?.isLock === "SALEPRICE"}
                              onChange={() =>
                                setProductData((prev) => ({
                                  ...prev,
                                  isLock: "SALEPRICE",
                                }))
                              }
                              className="position-absolute"
                              style={{
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                zIndex: 2,
                              }}
                            />
                          </div>
                          {error.saleprice && (
                            <div className="invalid-feedback">
                              {error.saleprice}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="taxpercentage" className="form-label">
                            Tax(%) <span className="text-danger">*</span>
                          </label>
                          <select
                            name="taxpercentage"
                            className="form-control"
                            ref={producttaxpercentageRef}
                            value={isProductData.taxpercentage}
                            onChange={handleChange}
                            onKeyDown={(e) =>
                              handleEnterKey(
                                e,
                                "taxpercentage",
                                productbasepriceRef,
                              )
                            }
                          >
                            <option value="0">0</option>
                            <option value="5">5</option>
                            <option value="12">12</option>
                            <option value="18">18</option>
                            <option value="24">24</option>
                          </select>
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="discount" className="form-label">
                            Discount
                          </label>
                          <input
                            readOnly=""
                            type="text"
                            name="discount"
                            autoComplete="off"
                            value={isProductData.discount}
                            className="form-control"
                            disabled
                          />
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="baseprice" className="form-label">
                            Base Price
                          </label>

                          <div className="input-container position-relative">
                            <input
                              type="text"
                              name="baseprice"
                              autoComplete="off"
                              ref={productbasepriceRef}
                              onClick={() => {
                                setProductData((prev) => ({
                                  ...prev,
                                  isLock: "BASEPRICE",
                                }));
                              }}
                              onChange={handleChange}
                              value={isProductData.baseprice}
                              onFocus={handleFieldFocus}
                              className="form-control"
                              style={{ paddingLeft: "30px" }}
                              onKeyDown={(e) =>
                                handleEnterKey(e, "baseprice", quantityRef)
                              }
                            />
                            <input
                              type="radio"
                              name="selectInput"
                              className="position-absolute"
                              checked={isProductData?.isLock === "BASEPRICE"}
                              onChange={() =>
                                setProductData((prev) => ({
                                  ...prev,
                                  isLock: "BASEPRICE",
                                }))
                              }
                              style={{
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                zIndex: 2,
                              }}
                            />
                          </div>
                          {error.baseprice && (
                            <div className="invalid-feedback">
                              {error.baseprice}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="taxamount" className="form-label">
                            Tax Amount
                          </label>
                          <input
                            readOnly=""
                            type="text"
                            name="taxamount"
                            autoComplete="off"
                            className="form-control"
                            value={isProductData.taxamount}
                            disabled
                          />
                        </div>

                        {/* <div className="col-lg-4">
                <label>Quantity</label>
                <input
                  type="number"
                  name="quantity"
                  className="form-control"
                  value={isProductData.quantity}
                  onChange={handleChange}
                />
              </div> */}

                        {viewOption(
                          "stockSettings",
                          "isManufactureAndExpiryDates",
                        ) && (
                          <>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <div className="col-lg-6">
                                <label className="form-label">
                                  Manufacture Date
                                </label>

                                <DatePicker
                                  open={openMfgDate}
                                  onOpen={() => setOpenMfgDate(true)}
                                  onClose={() => setOpenMfgDate(false)}
                                  disableOpenPicker
                                  value={
                                    isProductData?.manufacturedate
                                      ? dayjs(isProductData.manufacturedate)
                                      : null
                                  }
                                  format="DD MMM YYYY"
                                  maxDate={dayjs(iso)}
                                  onChange={(newValue) => {
                                    if (!newValue) return;
                                    handleMDateChange(newValue);
                                    setOpenMfgDate(false); // ✅ close even if date not picked later
                                  }}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      size: "small",
                                      onClick: () => setOpenMfgDate(true),
                                      inputProps: { readOnly: true },
                                      onKeyDown: (e) => e.preventDefault(),
                                      sx: {
                                        "& .MuiInputBase-input": {
                                          cursor: "pointer",
                                        },
                                      },
                                    },
                                    openPickerButton: {
                                      sx: { display: "none" },
                                    },
                                  }}
                                />
                              </div>

                              <div className="col-lg-6">
                                <label className="form-label">
                                  Expire Date
                                </label>

                                <DatePicker
                                  open={openExpDate}
                                  onOpen={() => setOpenExpDate(true)}
                                  onClose={() => setOpenExpDate(false)}
                                  disableOpenPicker
                                  value={
                                    isProductData?.expiredate
                                      ? dayjs(isProductData.expiredate)
                                      : null
                                  }
                                  format="DD MMM YYYY"
                                  minDate={dayjs(expireMinDate)}
                                  onChange={(newValue) => {
                                    if (!newValue) return;
                                    handleEDateChange(newValue);
                                    setOpenExpDate(false);
                                  }}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      size: "small",
                                      onClick: () => setOpenExpDate(true),
                                      inputProps: { readOnly: true },
                                      onKeyDown: (e) => e.preventDefault(),
                                      sx: {
                                        "& .MuiInputBase-input": {
                                          cursor: "pointer",
                                        },
                                      },
                                    },
                                    openPickerButton: {
                                      sx: { display: "none" },
                                    },
                                  }}
                                />
                              </div>
                            </LocalizationProvider>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="card h-100">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="mb-0">Purchase Details</h6>

                        <div className="d-flex align-items-center gap-2">
                          <span className="fw-600 ms-2 ">Add to Stock</span>

                          <div className="ms-auto custom-toggle-wrapper">
                            <label className="custom-toggle cursor-pointer">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={addToStock}
                                onChange={() => setAddToStock((prev) => !prev)}
                              />
                              <span className="slider">
                                {addToStock["stock"] ? (
                                  <span
                                    className={`spinner-inside ${
                                      addToStock["stock"] ? "spinner-right" : ""
                                    }`}
                                  />
                                ) : (
                                  <>
                                    {addToStock["stock"] ? (
                                      <span className="label-on ms-0-1"></span>
                                    ) : (
                                      <span className="label-off ms-3"></span>
                                    )}
                                  </>
                                )}
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-12">
                          <div className="row g-2">
                            <div className="col-md-6">
                              <label htmlFor="quantity" className="form-label">
                                Quantity <span className="text-danger">*</span>
                              </label>
                              <div className="input-group">
                                {/* Quantity Input */}
                                <input
                                  type="text"
                                  className="form-control"
                                  name="quantity"
                                  autoComplete="off"
                                  // ref={productMdateRef}
                                  ref={quantityRef}
                                  value={isProductData.quantity}
                                  onFocus={(e) => e.target.select()}
                                  onChange={handleChange}
                                  onKeyDown={(e) => {
                                    handleEnterKey(
                                      e,
                                      "quantity",
                                      purchasewithtaxref,
                                    );
                                  }}
                                />

                                {/* ✅ Show unit only if valid */}
                                {hasUnit &&
                                  (secondaryUnitCode ? (
                                    <select
                                      className="btn btn-unit shadow-none border-end rounded-end rounded-start-0 dropdown-toggle-split"
                                      value={selectedUnit}
                                      onChange={(e) => {
                                        const unit = e.target.value;

                                        setSelectedUnit(unit);

                                        setProductData((prev) => ({
                                          ...prev,
                                          quantity: 0,
                                          isSecondaryUnit:
                                            unit ===
                                            prev?.unitConfig?.secondaryUnitCode,
                                        }));
                                      }}
                                    >
                                      <option value={primaryUnitCode}>
                                        {primaryUnitCode}
                                      </option>
                                      <option value={secondaryUnitCode}>
                                        {secondaryUnitCode}
                                      </option>
                                    </select>
                                  ) : (
                                    <span className="btn btn-unit shadow-none border-end rounded-end rounded-start-0">
                                      {primaryUnitCode}
                                    </span>
                                  ))}
                              </div>

                              {error.quantity && (
                                <div className="invalid-feedback d-block">
                                  {error.quantity}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6">
                              <label className="form-label">
                                Rate / {(hasUnit && primaryUnitCode) || "Unit"}
                              </label>
                              <input
                                type="text"
                                disabled
                                className="form-control"
                                value={isProductData.ratePerUnit}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <label className="form-label">
                            Total Purchase Amount{" "}
                            <span className="text-danger">*</span>
                          </label>

                          <div className="row g-2">
                            {/* WITH TAX */}
                            <div className="col-md-6">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  ref={purchasewithtaxref}
                                  value={isProductData.purchaseWithTax}
                                  onFocus={(e) => e.target.select()}
                                  onClick={() => {
                                    setProductData((prev) => ({
                                      ...prev,
                                      totalPurchaseAmountLock: "WITHTAX",
                                    }));
                                  }}
                                  name="purchaseWithTax"
                                  onChange={handleChange}
                                  style={{ paddingLeft: "30px" }}
                                  onKeyDown={(e) =>
                                    handleEnterKey(
                                      e,
                                      "purchaseWithTax",
                                      purchasewithouttaxRef,
                                    )
                                  }
                                />
                                <input
                                  type="radio"
                                  checked={
                                    isProductData.totalPurchaseAmountLock ===
                                    "WITHTAX"
                                  }
                                  onChange={() =>
                                    setProductData((prev) => ({
                                      ...prev,
                                      totalPurchaseAmountLock: "WITHTAX",
                                    }))
                                  }
                                  className="position-absolute"
                                  style={{
                                    top: "50%",
                                    left: "10px",
                                    transform: "translateY(-50%)",
                                  }}
                                />
                              </div>
                              <small>With Tax</small>
                            </div>

                            {/* WITHOUT TAX */}
                            <div className="col-md-6">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  ref={purchasewithouttaxRef}
                                  value={isProductData.purchaseWithoutTax}
                                  onFocus={(e) => e.target.select()}
                                  onClick={() => {
                                    setProductData((prev) => ({
                                      ...prev,
                                      totalPurchaseAmountLock: "WITHOUTTAX",
                                    }));
                                  }}
                                  name="purchaseWithoutTax"
                                  onChange={handleChange}
                                  style={{ paddingLeft: "30px" }}
                                  onKeyDown={(e) => {
                                    handleEnterKey(
                                      e,
                                      "purchaseWithoutTax",
                                      null,
                                      true,
                                    );
                                  }}
                                />
                                <input
                                  type="radio"
                                  checked={
                                    isProductData.totalPurchaseAmountLock ===
                                    "WITHOUTTAX"
                                  }
                                  onChange={() =>
                                    setProductData((prev) => ({
                                      ...prev,
                                      totalPurchaseAmountLock: "WITHOUTTAX",
                                    }))
                                  }
                                  className="position-absolute"
                                  style={{
                                    top: "50%",
                                    left: "10px",
                                    transform: "translateY(-50%)",
                                  }}
                                />
                              </div>
                              <small>Without Tax</small>
                            </div>
                          </div>

                          {error.purchaseamount && (
                            <div className="invalid-feedback d-block">
                              {error.purchaseamount}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer d-block">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={handleClose}
              >
                <XIcon/> Cancel
              </button>
              {isBtnLoading ? (
                <button className="btn btn-teal pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-teal text-right"
                  onClick={handleUpdate}
                  ref={updateBtnRef}
                >
                  <CheckIcon/> Update Item
                </button>
              )}
            </div>

            {/* <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onclose}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleUpdate}>
              Update Item
            </button>
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditStockModel;
